import React, { PureComponent } from 'react';
import Button, { ButtonLink } from 'components/base/Button';

import { campaignPath } from 'app/routes';
import emptyCampaignsImage from '../../assets/images/empty-campaigns.svg';

import css from './style.scss';


class NoCampaigns extends PureComponent {
  render() {
    return (
      <div className={css.noCampaigns}>
        <div className={css.start}>
          <img 
            src={emptyCampaignsImage} 
            alt="No campaigns" 
            className={css.emptyStateImage}
          />
          <div className={css.title}>You Have No Ongoing Campaigns</div>
          <div className={css.subtitle}>Start your first campaign now.</div>
          <ButtonLink to={campaignPath('new')} kind={Button.kind.grayGhost} size={Button.size.middle} className={css.btn}>New Campaign</ButtonLink>
        </div>
      </div>
    );
  }
}

export default NoCampaigns;
